import React from "react";
import { Path } from "enums";
import { Route, Switch, Redirect } from "react-router-dom";
import SettlementHistoryModule from "modules/cash-flow/settlement-history/settlement-history.module";
import ViewSettlementHistory from "modules/cash-flow/settlement-history/view-settlement-history/view-settlement-history.module";
import UpdateSettlement from "modules/cash-flow/settlement/update-settlement/update-settlement.module";

const SettlementHistoryPage = () => {
  return (
    <Switch>
      <Route exact path={Path.LocqSettlementHistory} component={SettlementHistoryModule} />
      <Route exact path={Path.ViewSettlementHistory} component={ViewSettlementHistory} />
      <Route exact path={Path.UpdateSettlement} component={UpdateSettlement} />
      <Redirect to={Path.ViewSettlementHistory} />
    </Switch>
  );
};

export default SettlementHistoryPage;
